import { httpTokenCommon } from "../helper/http-common";

class KycService {
	getKycTileCountsAPI(inputData) {
		return httpTokenCommon.post("kyc/TileCounts", inputData);
	}

	getKycGroupCompanyListAPI(inputData) {
		return httpTokenCommon.post("kyc/GroupCompany/List", inputData);
	}

	getKycCompanyListAPI(inputData) {
		return httpTokenCommon.post("kyc/Company/List", inputData);
	}

	getKycMaterialMasterListAPI(inputData) {
		return httpTokenCommon.post("kyc/MaterialMaster/List", inputData);
	}

	getKycDesignMasterListAPI(inputData) {
		return httpTokenCommon.post("kyc/DesingMasterListing/List", inputData);
	}

	getKycDesignDetailsListAPI(inputData) {
		return httpTokenCommon.post("kyc/DesingDetails/List", inputData);
	}

	getKycQuotationMasterListAPI(inputData) {
		return httpTokenCommon.post("kyc/QuotationMasterListing/List", inputData);
	}

	getKycOrderMasterListAPI(inputData) {
		return httpTokenCommon.post("kyc/OrderMasterListing/List", inputData);
	}

	getKycOrderDetailListAPI(inputData) {
		return httpTokenCommon.post("kyc/OrderDetailListing/List", inputData);
	}

	getKycQuotationDetailListAPI(inputData) {
		return httpTokenCommon.post("kyc/QuotationDetailListing/List", inputData);
	}

	getQuotationContactDataByIdAPI(inputData) {
		return httpTokenCommon.post("kyc/Quotation/ContactDataById", inputData);
	}

	getKycMaterialCharacteristicsListAPI(inputData) {
		return httpTokenCommon.post("kyc/MaterialCharacteristics/List", inputData);
	}

	getPrimaryContactDataBySapCodeAPI(sapCode) {
		return httpTokenCommon.post(`kyc/GetPrimaryContactDataBySapCode?SAPCode=${encodeURIComponent(sapCode)}`);
	}

	getPartnerFunctionByCompanyGuidAPI(crmGuid) {
		return httpTokenCommon.post(`kyc/GetPartnerFunctionByCompanyGUID?CrmGuid=${encodeURIComponent(crmGuid)}`);
	}

	getKycGlobalFiltersAPI() {
		return httpTokenCommon.get("kyc/GlobalFilters");
	}
}

const kycService = new KycService();
export default kycService;
